import { render, staticRenderFns } from "./SkipTutorialDialog.vue?vue&type=template&id=7e6a47cc&"
import script from "./SkipTutorialDialog.vue?vue&type=script&lang=js&"
export * from "./SkipTutorialDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports